// Uses anime.js (https://animejs.com/documentation/)
export const ANIMATIONS = {
	fadeIn: {
		opacity: [0, 1],
		duration: 1000,
		easing: 'easeOutQuad',
	},
	ribbonSlideInLeft: {
		opacity: [0, 0.6],
		translateX: ['-50%', 0],
		duration: 1000,
		easing: 'easeOutQuad',
	},
	slideInLeft: {
		opacity: [0, 1],
		translateX: ['-50%', 0],
		duration: 1000,
		easing: 'easeOutQuad',
	},
	slideInRight: {
		opacity: [0, 1],
		translateX: ['50%', 0],
		duration: 500,
		easing: 'easeOutQuad',
	},
	slideInTop: {
		opacity: [0, 1],
		translateY: ['-50%', 0],
		duration: 500,
		easing: 'easeOutQuad',
	},
	slideInBottom: {
		opacity: [0, 1],
		translateY: ['50%', 0],
		duration: 500,
		easing: 'easeOutQuad',
	},
};
